<template>
  <v-card :disabled="disabled" class="pa-5 my-5">
    <v-card-text>
      <draggable-form
        v-model="form"
        :languages="languages"
        @edit="edit"
        @add="add"
      ></draggable-form>

      <v-dialog v-if="dialog" v-model="dialog" max-width="500px">
        <v-form v-model="valid">
          <component
            :is="formName(dialogForm.el.type)"
            v-model="dialogForm"
            :languages="languages"
            @cancel="cancelDialog"
          >
            <template v-slot:buttons>
              <v-btn outlined depressed color="grey" @click="cancelDialog">
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!valid"
                depressed
                color="primary"
                @click="saveDialog"
              >
                {{ $t('BUTTON.SAVE') }}
              </v-btn>
            </template>
          </component>
        </v-form>
      </v-dialog>
    </v-card-text>
    <v-card-actions>
      <slot name="buttons" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import DraggableForm from '@/modules/form_builder/components/forms/DraggableForm';
import editComponents from '@/modules/form_builder/components/mixins/edit-components';
import { mapCacheActions } from 'vuex-cache';
import { CREATE, EDIT } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'CreateFormPage',

  components: {
    DraggableForm
  },

  mixins: [editComponents],

  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    languages: [],
    valid: false,
    dialog: false,
    form: [],
    dialogForm: {},
    formType: null
  }),

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    },
    form: {
      deep: true,
      immediate: true,
      handler: 'formemitter'
    }
  },

  created() {},

  mounted() {
    this.retrieveLanguages().then(response => {
      this.languages = response.data;
    });
  },

  methods: {
    ...mapCacheActions('localization', ['retrieveLanguages']),
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.form)) {
        return;
      }

      this.form = cloneDeep(formProps);

      this.emitter();
    },

    emitter() {
      this.$emit('input', cloneDeep(this.form));
    },

    formemitter() {
      if (isEqual(this.value, this.form)) {
        return;
      }
      this.emitter();
    },

    setFormData(el) {
      this.dialogForm = cloneDeep(el);
      this.dialog = true;
    },

    edit(el) {
      this.formType = EDIT;
      this.setFormData(el);
    },

    add(el) {
      this.formType = CREATE;
      this.setFormData(el);
    },

    saveDialog() {
      this.form[this.dialogForm.key] = this.dialogForm.el;
      this.form = cloneDeep(this.form);
      this.clearDialog();
    },

    cancelDialog() {
      if (this.formType === CREATE) {
        this.form.splice(this.dialogForm.key, 1);
      }
      this.clearDialog();
    },

    clearDialog() {
      this.dialog = false;
      this.dialogForm = {};
      this.formType = null;
    }
  }
};
</script>
